export default __webpack_public_path__ + "static/media/person.e2c34d43.webp";